document.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("ma-welcome");
  if (!modal) return;

  const closeBtn = modal.querySelector(".ma-welcome__close");
  const declineBtn = modal.querySelector(".ma-welcome__decline");
  const backdrop = modal.querySelector(".ma-welcome__backdrop");
  const form = modal.querySelector("form");

  const STORAGE_KEY = "ma_welcome_closed";

  const closeModal = () => {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("overflow-hidden");
    document.body.classList.remove("overflow-hidden");
    sessionStorage.setItem(STORAGE_KEY, "1");
  };

  // Open modal unless already closed this session
  const alreadyClosed = sessionStorage.getItem(STORAGE_KEY) === "1";
  if (!alreadyClosed) {
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("overflow-hidden");
    document.body.classList.add("overflow-hidden");
  }

  // Close handlers
  closeBtn?.addEventListener("click", closeModal);
  declineBtn?.addEventListener("click", closeModal);
  backdrop?.addEventListener("click", closeModal);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeModal();
  });

  // Close immediately on submit so user isn't stuck
  form?.addEventListener("submit", () => {
    sessionStorage.setItem(STORAGE_KEY, "1");
    // give the browser a beat to submit, then hide
    setTimeout(closeModal, 150);
  });

  // If Shopify redirects back with success params, close it
  const params = new URLSearchParams(window.location.search);
  const submitted =
    params.get("customer_posted") === "true" ||
    params.get("contact_posted") === "true" ||
    window.location.hash.includes("contact_form");

  if (submitted) closeModal();
});
